import { useEffect,useState } from 'react';
import Select from 'react-select'

import { storage as confStorage } from '../../config';
import { productsBasic, productsIntermediate, productsAdvanced } from '../../data/products';

const storageFilters = JSON.parse(localStorage.getItem(confStorage.productFilters)) || ['basic', 'intermediate', 'advanced'];

const ProductSelect = ({ value, onChange }) => {
	const [options, setOptions] = useState([
		{ label: 'Basic', options: productsBasic.map((p) => ({ value: p.id, label: p.name })) },
		{ label: 'Intermediate', options: productsIntermediate.map((p) => ({ value: p.id, label: p.name })) },
		{ label: 'Advanced', options: productsAdvanced.map((p) => ({ value: p.id, label: p.name })) },
	]);
	const [filter, setFilter] = useState(storageFilters);
	const selectedValue = options.find((p) => p.value === value);

	const selectStyles = {
		option: (styles, { data }) => {
			return {
				...styles,
				display: 'flex',
				alignItems: 'center',
				'::before': {
					content: '" "',
					display: 'inline-block',
					width: '24px',
					height: '24px',
					marginRight: '0.25rem',
					backgroundImage: `url(./assets/items/${data.value}.gif)`,
					backgroundRepeat: 'no-repeat',
				},
			};
		},
		singleValue: (styles, { data }) => {
			return {
				...styles,
				display: 'flex',
				alignItems: 'center',
				'::before': {
					content: '" "',
					display: 'inline-block',
					width: '24px',
					height: '24px',
					marginRight: '0.25rem',
					backgroundImage: `url(./assets/items/${data.value}.gif)`,
					backgroundRepeat: 'no-repeat',
				},
			};
		},
	};

	useEffect(() => {
		const filteredOptions = [];
		if (filter.includes('basic')) {
			filteredOptions.push({ label: 'Basic', options: productsBasic.map((p) => ({ value: p.id, label: p.name })) });
		}
		if (filter.includes('intermediate')) {
			filteredOptions.push({ label: 'Intermediate', options: productsIntermediate.map((p) => ({ value: p.id, label: p.name })) });
		}
		if (filter.includes('advanced')) {
			filteredOptions.push({ label: 'Advanced', options: productsAdvanced.map((p) => ({ value: p.id, label: p.name })) });
		}
		setOptions(filteredOptions);
	}, [filter]);

	const onChangeFilter = (e) => {
		const isChecked = e.target.checked;
		if (!isChecked && filter.length === 1) {
			return;
		}
		const newFilters = isChecked ? [...filter, e.target.value] : filter.filter((f) => f !== e.target.value);
		setFilter(newFilters);
		localStorage.setItem(confStorage.productFilters, JSON.stringify(newFilters));
	};

	return (
		<div className={'product-select-wrapper'}>
			<Select
				placeholder={'-- Please choose a product --'}
				options={options}
				value={selectedValue}
				onChange={(option) => onChange({ target: { value: option.value } })}
				styles={selectStyles}
			/>
			<div className={'product-select__filter'}>
				<label htmlFor="product-select__filter__basic">
					<input
						type="checkbox"
						id="product-select__filter__basic"
						name="product-select__filter__basic"
						value="basic"
						checked={filter.includes('basic') ? 'checked' : ''}
						onChange={onChangeFilter}
					/>
					<span>Basic</span>
				</label>
				<label htmlFor="product-select__filter__intermediate">
					<input
						type="checkbox"
						id="product-select__filter__intermediate"
						name="product-select__filter__intermediate"
						value="intermediate"
						checked={filter.includes('intermediate') ? 'checked' : ''}
						onChange={onChangeFilter}
					/>
					<span>Intermediate</span>
				</label>
				<label htmlFor="product-select__filter__advanced">
					<input
						type="checkbox"
						id="product-select__filter__advanced"
						name="product-select__filter__advanced"
						value="advanced"
						checked={filter.includes('advanced') ? 'checked' : ''}
						onChange={onChangeFilter}
					/>
					<span>Advanced</span>
				</label>
			</div>
		</div>
	);
};

export default ProductSelect;
